import React from 'react'
import PropTypes from 'prop-types'
import {intlShape} from "react-intl"
import HeaderMenu from '../components/header/HeaderMenu'
import NotifierComponent from '../components/notifier/NotifierComponent'
import '../utils/testMobile'
import cx from 'classnames'

const MainLayout = (props, context) => {
	const { intl } = context
	const ua = navigator.userAgent
	const isIE = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1
	return (
		<div>
			<HeaderMenu {...props} />
			<section className={cx('main-content', { 'main-content--ie': isIE })}>
				{props.children}
			</section>
			<NotifierComponent />
			<a className="cookies-settings" onClick={() => Optanon.ToggleInfoDisplay()}>{intl.formatMessage({id: 'buttons.cookies' })}</a>
		</div>
	)
}

MainLayout.propTypes = {
	children: PropTypes.element.isRequired
}

MainLayout.contextTypes = {
	intl: intlShape
}

export default MainLayout



// WEBPACK FOOTER //
// ./src/containers/MainLayout.js